import {
  watch, type WatchHandle,
  type WatchOptions,
  type WatchSource
} from 'vue'

export function watchUntilStopped<T>(
  source: WatchSource<T>,
  effect: (value: T, complete: () => void) => void,
  options?: Omit<WatchOptions, 'once'>): void {
  let hasExecuted = false
  let stop: WatchHandle | undefined = undefined

  stop = watch(
    source,
    value => {
      if (hasExecuted) {
        stop?.()
        return
      }

      effect(
        value,
        () => {
          hasExecuted = true
          stop?.()
        }
      )
    },
    options
  )
}
